export const CARD_BOARD_NAME_ANIMATION_TIMING = 1500; // также менять в _CardBoardName.scss
export const IS_SHOWED_CARD_BOARD_NAME_ANIMATION_SESSIONSTORAGE = 'IS_SHOWED_CARD_NAME_ANIMATION_LOCALSTORAGE';
